import React from 'react';
import SSRAwareQuery from '../SSRAwareQuery';
import gql from 'graphql-tag';
import DefaultHeroImage from './DefaultHeroImage';
import PropTypes from 'prop-types';

const query = gql`
  query configs {
    application(name: HOTELONLYBOOKING) {
      ... on HotelOnlyBooking {
        configurations {
          sunseekerAirportCodes
          defaultHeroImage
          sunseekerHeroImage
        }
      }
    }
  }
`;
const propTypes = { destination: PropTypes.string };

const HeroImage = ({ destination }) => {
  return (
    <SSRAwareQuery query={query}>
      {({ loading, error, data }) => {
        if (error) {
          throw error;
        }

        if (loading) {
          return null;
        }

        const sunseekerAirportCodes =
          data?.application?.configurations?.sunseekerAirportCodes;
        const defaultHeroImage =
          data?.application?.configurations?.defaultHeroImage;
        const sunseekerHeroImage =
          data?.application?.configurations?.sunseekerHeroImage;
        const isSunseekerAirport = sunseekerAirportCodes.includes(destination);
        return (
          <DefaultHeroImage
            defaultHeroImage={
              isSunseekerAirport ? sunseekerHeroImage : defaultHeroImage
            }
          />
        );
      }}
    </SSRAwareQuery>
  );
};

HeroImage.propTypes = propTypes;
export default HeroImage;
